import { createAction, createStandardAction } from 'typesafe-actions'

export interface FreeTrialPayload {
  origin: string | undefined
}

export interface FreeTrialMeta {
  origin?: string
}

export const handleFreeTrialStart = createAction(
  'payment/HANDLE_FREE_TRIAL_START',
  resolve => {
    return (origin?: string) =>
      resolve({ origin } as FreeTrialPayload, { origin } as FreeTrialMeta)
  }
)

export const paymentSuccess = createStandardAction('payment/PAYMENT_SUCCESS')()
export const gainEntitledChecks = createStandardAction('payment/GAIN_ENTITLED_CHECKS')()



// WEBPACK FOOTER //
// ./src/state/payment/actions.ts